import styles from './ContactForm.module.scss'

import React from 'react'
import PropTypes from 'prop-types'
import produce from 'immer'

import Button from './Button'

import { questions } from '../../config'

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

class ContactForm extends React.Component {
  getInitialState = () => {
    return {
      fields: {
        nome: {
          value: '',
          error: false,
        },
        contacto: {
          value: '',
          error: false,
        },
        mensagem: {
          value: '',
        },
      },
    }
  }

  state = this.getInitialState()

  reset = () => {
    this.setState(this.getInitialState())
  }

  onFieldChange = event => {
    const { name, value } = event.target
    this.setState(
      produce(draft => {
        draft.fields[name].value = value
        draft.fields[name].error = false
      })
    )
  }

  getRespostas = () => {
    const { price, answers } = this.props

    const answersList = answers.map((answerIndex, questionIndex) => {
      const question = questions[questionIndex]
      const answer = question.answers[answerIndex]
      let cost = 0
      let costMultiplier = 1
      if (answer.cost !== undefined) {
        cost = answer.cost
      } else if (answer.costMultiplier !== undefined) {
        costMultiplier = answer.costMultiplier
      } else {
        cost = answer.costAndMultiplier[0]
        costMultiplier = answer.costAndMultiplier[1]
      }

      let costStr = ''
      if (cost !== 0) {
        costStr += cost + '€   '
      }
      if (costMultiplier !== 1) {
        costStr += 'x' + costMultiplier
      }

      return {
        question: question.title,
        answer: answer.title,
        cost: costStr.trim() || 0,
      }
    })

    return JSON.stringify(
      {
        totalCost: price + '€',
        answers: answersList,
      },
      null,
      4
    )
  }

  onSubmit = event => {
    event.preventDefault()
    const { fields } = this.state
    const { onSubmitSuccessful } = this.props
    let hasErrors = false
    for (const fieldName of ['nome', 'contacto']) {
      this.setState(
        produce(draft => {
          draft.fields[fieldName].error = false
        })
      )
      if (!fields[fieldName].value) {
        hasErrors = true

        this.setState(
          produce(draft => {
            draft.fields[fieldName].error = true
          })
        )
      }
    }
    if (!hasErrors) {
      window
        .fetch('/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: encode({
            'form-name': 'contact',
            nome: fields.nome.value,
            contacto: fields.contacto.value,
            mensagem: fields.mensagem.value,
            respostas: this.getRespostas(),
          }),
        })
        .then(() => {
          this.reset()
          onSubmitSuccessful()
        })
        .catch(error => window.alert(error))
    }
  }

  render () {
    const { fields } = this.state
    return (
      <form
        name="contact"
        className={styles.form}
        data-netlify="true"
        data-netlify-honeypot="hidden-field"
      >
        <input className="hidden" name="hidden-field" placeholder="Nome" type="text" />

        <div className={styles.formRow}>
          <div className={styles.formCol}>
            <label htmlFor="nameField">Nome</label>
            <input
              id="nameField"
              name="nome"
              type="text"
              className={fields.nome.error ? 'error' : ''}
              value={fields.nome.value}
              onChange={this.onFieldChange}
              data-hj-whitelist
            />
            <label htmlFor="contactField">Contacto</label>
            <input
              id="contactField"
              name="contacto"
              type="text"
              className={fields.contacto.error ? 'error' : ''}
              value={fields.contacto.value}
              onChange={this.onFieldChange}
              data-hj-whitelist
            />
          </div>
          <div className={styles.formCol}>
            <label htmlFor="messageField">Mensagem</label>
            <textarea
              id="messageField"
              name="mensagem"
              cols="30"
              rows="4"
              value={fields.mensagem.value}
              onChange={this.onFieldChange}
              data-hj-whitelist
            />
          </div>

          <input className="hidden" name="respostas" placeholder="Respostas" type="text" />
        </div>
        <Button className={styles.button} onClick={this.onSubmit}>
          Enviar
        </Button>
      </form>
    )
  }
}

ContactForm.propTypes = {
  price: PropTypes.number.isRequired,
  answers: PropTypes.arrayOf(PropTypes.number).isRequired,
  onSubmitSuccessful: PropTypes.func.isRequired,
}

export default ContactForm
